import { render, staticRenderFns } from "./WebHome.vue?vue&type=template&id=1044a743&scoped=true&"
import script from "./WebHome.vue?vue&type=script&lang=js&"
export * from "./WebHome.vue?vue&type=script&lang=js&"
import style0 from "./WebHome.vue?vue&type=style&index=0&id=1044a743&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1044a743",
  null
  
)

export default component.exports